import { ImageFile } from "components/ImageUpload";
import { FC, ReactElement } from "react";

export interface BaseOption {
  value: string;
  label: string;
  disabled?: boolean;
  style?: React.CSSProperties;
  [key: string]: unknown;
}

export enum HttpStatus {
  OK = 200,
  Created = 201,
  NoContent = 204,
  BadRequest = 400,
  Unauthorized = 401,
  ExpiredSubscribe = 402,
  Forbidden = 403,
  NotFound = 404,
  Conflict = 409,
  Gone = 410,
  LargeRequest = 413,
  UnprocessableEntity = 422,
  ManyRequests = 429,
  InternalServerError = 500,
}

export enum ModalType {
  NOTICE = "notice",
  USER = "user",

  CREATE_ASSET = "create-asset",
  CREATE_COMPANY = "create-company",
  CREATE_PORTFOLIO = "create-portfolio",
  CREATE_GATEWAY = "create-gateway",
  CREATE_DEVICE = "create-device",
  GENERATE_REPORT = "generate-report",
  MARK_CALIBRATED = "mark-calibrated",
  GATEWAY_CONFIG_INSTRUCTIONS = "gateway-config-instructions",

  REMOVE_USER = "remove-user",
  REMOVE_ASSET = "remove-asset",
  REMOVE_DEVICE = "remove-device",
  REMOVE_COMPANY = "remove-company",
  REMOVE_PORTFOLIO = "remove-portfolio",
  REMOVE_REPORT = "remove-report",
  REMOVE_GATEWAY = "remove-gateway",

  WHATSAPP_VERIFICATION = "whatsapp-verification",
}

export enum UserRole {
  ADMINISTRATOR = "administrator",
}

export type LayoutProps = {
  title?: string;
  description?: ReactElement | string;
  isBackButton?: boolean;
  backButtonLink?: string;
  children?: ReactElement;
};

export type RoutesType = {
  Layout?: FC<LayoutProps>;
  layoutProps?: LayoutProps;
  element: ReactElement;
  name: string;
  path: string;
  isPrivate?: boolean;
};

export type Meta = {
  total: number;
  page: number;
  page_size: number;
  total_pages: number;
};

export type PhoneNumberCodeType = {
  alpha3Code: string;
  callingCode: string;
  countryCode: string;
  search: string;
};

export type ImageType = {
  id: number;
  filename: string;
  original_name: string;
  url: string;
  size: number;
  position: number;
};

export type UserStatistics = {
  total: number;
  active: number;
  pending: number;
  invitation_expired: number;
};

export type IncidentStatistics = {
  total_active: number;
  active_high: number;
  resolved_last_30d: number;
};

export type DeletionInfo = {
  user_id: number;
  full_name: string;
  managed_portfolios: ManagedPortfolio[];
  managed_assets: ManagedAsset[];
};

export type ManagedPortfolio = {
  portfolio_id: number;
  portfolio_name: string;
};

export type ManagedAsset = {
  asset_id: number;
  asset_name: string;
};

export type RemoveUserRequest = {
  reassignments: { portfolio_id: number; new_manager_id: number }[];
  asset_reassignments: { asset_id: number; new_manager_id: number }[];
};

export type PortfolioStatistics = {
  compliance_score: number | null;
  compliance_score_level: "high" | "medium" | "low" | "insufficient";
  compliance_improvement: number | null;
  compliance_improvement_level: "up" | "down" | "flat" | "insufficient";
  avg_incidents_per_month: number | null;
  avg_incidents_level: "no_data" | "low" | "medium" | "high";
  total_portfolios: number;
  total_assets: number;
  scope: "all_companies" | "across_company";
};

export type AssetFormValues = {
  name: string;
  type: string;
  description: string;
  number: string;
  managerId: string;
  images: ImageFile[];
};
